<template>
  <v-dialog v-model="dialog.show" max-width="500px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          class="mx-2"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          fab
          small
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                v-on="on"
                dark
            >
              mdi-plus
            </v-icon>
          </template>
          create new customer
        </v-tooltip>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">new customer</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-text-field
                v-model="customerItem.name"
                label="name"
            />
          </v-row>
          <v-row>
            <v-autocomplete
                v-model="customerItem.application_id"
                :items="applicationsList"
                :filter="nonDiacriticsSensitiveFilter"
                label="Application"
                item-text="name"
                item-value="application_id"
                clearable
            />
          </v-row>
          <v-row>
            <v-text-field
                v-model="customerItem.dgAlias"
                label="destination guide alias"
            />
          </v-row>
          <v-row>
            <v-col cols="6">

              <v-switch
                  v-model="customerItem.isActive"
                  label="is active"
                  class="pa-3"
              />
            </v-col>
            <v-col cols="6">
              <v-switch
                  v-model="customerItem.isNative"
                  label="is native"
                  class="pa-3"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-select
                v-model="customerItem.applicationType"
                :items="applicationTypes"
                label="application type"
                clearable
            />
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog.show=false"
            :disabled="dialog.saving"
        >
          Cancel
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="dialog.saving"
            :loading="dialog.saving"
            @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'CustomerForm',
  data: () => ({
    dialog: {
      saving: false,
      show: false,
    },

    customerItem: {
      name: '',
      id: null,
      dgAlias: '',
      isActive: true,
      isNative: false,
      application_id: null,
      applicationType: null,
    },

    applicationsList: [],
    applicationTypes: ['WWF', 'Cloud', 'Native', 'WebApp'],
  }),
  created() {
    this.$requestHelpers
      .get('api/admin/customer/getApplicationsList')
      .then((response) => {
        this.applicationsList = response.data.result.map(
          // eslint-disable-next-line array-callback-return,max-len
          (item) => ({ application_id: parseInt(item.application_id, 10), name: item.name }),
        );
      });
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    save() {
      this.dialog.saving = false;

      this.axios
        .post('api/admin/customer',
          {
            name: this.customerItem.name,
            application_id: this.customerItem.application_id,
            is_active: this.customerItem.isActive,
            is_native: this.customerItem.isNative,
            dg_alias: this.customerItem.dgAlias,
            application_type: this.customerItem.applicationType,
          }).then((response) => {
          if (!response.data.success) {
            this.setSnack({
              color: 'red',
              text: response.data.message,
            });
            return;
          }
          this.setSnack({
            color: 'green',
            text: 'saved',
          });

          this.$emit('create', response.data.result);

          this.customerItem.name = '';
          this.customerItem.dgAlias = '';
          this.customerItem.isActive = true;
          this.customerItem.isNative = false;
          this.customerItem.id = null;
          this.customerItem.application_id = null;
          this.customerItem.applicationType = null;

          this.dialog.show = false;
        }).catch((error) => {
          let message = 'error';

          if (error.response && error.response.data.message) {
            message = error.response.data.message;
          }

          this.setSnack({
            snack: true,
            color: 'red',
            text: message,
          });
        }).finally(() => {
          this.dialog.saving = false;
        });
    },
  },
};
</script>
